import { Divider } from '@mui/material';
import { styled } from '@mui/material';

import { DESKTOP_MIN_WIDTH, TABLET_MIN_WIDTH } from '~/constants/common';
import { COLORS } from '~/styles/colors';

import bg from './assets/bg.png';

export const StyledContainer = styled('footer')(({ theme }) => ({
  backgroundImage: `url(${bg})`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundColor: 'black',
  color: 'white',
  display: 'flex',
  justifyContent: 'center',
  paddingBlock: '100px',
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    paddingBlock: '60px',
  },
}));

export const FooterSections = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
    flexDirection: 'column',
  },
}));

export const LogoSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 5,
  [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
    marginBottom: 24,
  },
}));

export const FooterSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flex: 4,
  flexDirection: 'column',
  alignItems: 'flex-start',
  [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
    marginBottom: 24,
  },
}));

export const FooterBottom = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
    marginBottom: 24,
    flexDirection: 'column',
  },
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  backgroundColor: COLORS.grey250,
  margin: '60px 0 32px 0',
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    marginTop: 40,
  },
  [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
    marginTop: 32,
  },
}));
